/* ARRAY - quick add. 29 Sep 2026.
   Loaded from snippets/beyondads-home-extra.liquid (homepage) and sections/beyondads-collection.liquid
   (collection pages). Each part only acts when its cards exist.

   1. HOMEPAGE: a round "+" under every product card in the custom sections that had no add button:
      the everyday edit (.dh-cell), the brand rows (.ar-cell), K-Beauty (.kb2-item), supplements and
      baby care (.su-card).
   2. COLLECTION PAGES (.bc-card): a tala sophie style stepper on the bottom-right of the photo - a
      white pill with a soft shadow. Just "+" while the product is not in the bag, "- n +" once it is;
      the number is the real bag quantity and follows changes made in the drawer.
   3. EVERY "+" opens the cart drawer - ours, Best Sellers' (.gt-add / [data-gt-all]) and the hero
      picks' (.bah-pick-add). Those two already add and announce `cart:update` themselves, so clicking
      one arms a one-shot opener for the next cart:update. "-" never opens it.
   EVERY + ADDS, it never opens the product page (30 Sep 2026, client: "+ takes me to the product page").
   Several variants: the shade picked on the card's swatches (the card links carry ?variant=), else the
   first available variant; the drawer then shows exactly what went in.
   COLLECTION STEPPER SITS OUTSIDE THE PHOTO LINK: the photo <a> is wrapped in .bq-mwrap and the stepper is
   its sibling, so a tap on it is never a tap on the link. Touch taps are also handled on touchend (with
   the synthesized click swallowed) - phones could otherwise follow the card link.
   Horizon contract, same as beyondads-bestsellers.js: POST /cart/add.js (or change.js) with the
   cart-items section ids, then a `cart:update` CustomEvent carrying the returned markup, then
   cart-drawer-component.open(). Clicks are caught on document in the CAPTURE phase so the card's own
   link and the rails' drag handlers never see them. */
(function () {
  'use strict';
  if (window.__bqAdd) return;
  window.__bqAdd = true;

  var CARDS = '.beyondads-edit .dh-cell, .beyondads-brandrow .ar-cell, .beyondads-kbeauty-section .kb2-item, ' +
              '.beyondads-supplements .su-card, .beyondads-babycare .su-card';
  var THEIRS = '.gt-add, [data-gt-add], [data-gt-all], .bah-pick-add';
  var PLUS = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" aria-hidden="true"><path d="M6 1.8v8.4M1.8 6h8.4"/></svg>';
  var MINUS = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" aria-hidden="true"><path d="M1.8 6h8.4"/></svg>';
  var TICK = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m2.4 6.3 2.4 2.4 4.8-5.2"/></svg>';

  var css = document.createElement('style');
  css.textContent =
    '.bq-add{display:grid;place-items:center;align-self:center;width:32px;height:32px;margin:12px auto 0;padding:0;' +
    'border:1px solid #D9D0CC;border-radius:50%;background:#fff;color:#1C1A19;cursor:pointer;flex:none;position:relative;z-index:2;' +
    'transition:border-color .2s,background-color .2s,color .2s}' +
    '.bq-add svg{display:block;width:12px;height:12px}' +
    '.bq-add:hover{border-color:#1C1A19}' +
    '.bq-add:focus-visible{outline:2px solid #1C1A19;outline-offset:2px}' +
    '.bq-add.is-busy{opacity:.45;cursor:progress}' +
    '.bq-add.is-done{background:#4E7A68;border-color:#4E7A68;color:#fff}' +
    /* collection stepper */
    '.bq-mwrap{position:relative;display:block}' +
    '.bq-step{position:absolute;right:10px;bottom:10px;z-index:3;display:flex;align-items:center;gap:2px;height:38px;padding:4px;' +
    'border-radius:999px;background:#fff;box-shadow:0 2px 10px rgba(0,0,0,.14);color:#1C1A19;cursor:default}' +
    '.bq-step button{display:grid;place-items:center;width:30px;height:30px;padding:0;border:0;border-radius:50%;background:none;' +
    'color:inherit;cursor:pointer;transition:background-color .2s}' +
    '.bq-step button:hover{background:#F3EFED}' +
    '.bq-step button:focus-visible{outline:2px solid #1C1A19;outline-offset:1px}' +
    '.bq-step svg{display:block;width:12px;height:12px}' +
    '.bq-step .bq-dec,.bq-step .bq-n{display:none}' +
    '.bq-step.has-qty .bq-dec{display:grid}' +
    '.bq-step.has-qty .bq-n{display:block}' +
    '.bq-n{min-width:16px;text-align:center;font-size:13px;line-height:1;font-variant-numeric:tabular-nums}' +
    '.bq-step.is-busy{opacity:.6;pointer-events:none}' +
    '@media (max-width:749px){.bq-step{right:8px;bottom:8px;height:34px;padding:3px}.bq-step button{width:28px;height:28px}}';
  document.head.appendChild(css);

  function sectionIds() {
    return Array.prototype.map.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (c) {
      return c.getAttribute('data-section-id');
    });
  }
  function openDrawer() {
    var d = document.querySelector('cart-drawer-component');
    if (d && typeof d.open === 'function') d.open();
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function announce(res, productId) {
    var count = (res.items || []).reduce(function (s, i) { return s + (i.quantity || 0); }, 0);
    if (typeof res.item_count === 'number') count = res.item_count;
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
      resource: {}, sourceId: 'beyondads-quickadd',
      data: { source: 'product-form-component', itemCount: count, productId: productId, sections: res.sections || {} }
    } }));
  }
  function withSections(body) {
    var ids = sectionIds();
    if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
    return body;
  }

  function handleOf(card) {
    var a = card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
    if (!a) return '';
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function nameOf(card) {
    var t = card.querySelector('h3,h4,[class*="name"],[class*="title"]');
    return t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  /* the variant picked on the card (swatch clicks re-point its links to ?variant=) */
  function pickedOf(card) {
    if (!card) return 0;
    var links = card.querySelectorAll('a[href*="variant="]');
    for (var i = 0; i < links.length; i++) {
      var m = links[i].getAttribute('href').match(/[?&]variant=(\d+)/);
      if (m) return +m[1];
    }
    if (card.matches && card.matches('a[href*="variant="]')) {
      var m2 = card.getAttribute('href').match(/[?&]variant=(\d+)/);
      if (m2) return +m2[1];
    }
    return 0;
  }

  /* add one of a product by handle. Resolves true when added. */
  function addHandle(h, card) {
    return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var avail = (p.variants || []).filter(function (v) { return v.available; });
        if (!avail.length) throw new Error('sold out');
        var pick = pickedOf(card), vid = avail[0].id;
        for (var i = 0; i < avail.length; i++) if (avail[i].id === pick) vid = pick;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(withSections({ items: [{ id: vid, quantity: 1 }] }))
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (!res || res.status >= 400 || res.errors) throw new Error('add failed');
          announce(res, p.id);
          openDrawer();
          return true;
        });
      });
  }

  /* ---- 1. homepage "+" ---- */
  function injectHome() {
    Array.prototype.forEach.call(document.querySelectorAll(CARDS), function (card) {
      if (card.querySelector('.bq-add')) return;
      var h = handleOf(card);
      if (!h) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bq-add';
      b.setAttribute('data-handle', h);
      var n = nameOf(card);
      b.setAttribute('aria-label', n ? 'Add ' + n + ' to bag' : 'Add to bag');
      b.innerHTML = PLUS;
      card.appendChild(b);
    });
  }
  function homeAdd(b) {
    if (b.classList.contains('is-busy')) return;
    b.classList.add('is-busy');
    addHandle(b.getAttribute('data-handle'), b.parentElement).then(function (ok) {
      b.classList.remove('is-busy');
      if (!ok) return;
      b.classList.add('is-done');
      b.innerHTML = TICK;
      setTimeout(function () { b.classList.remove('is-done'); b.innerHTML = PLUS; }, 1800);
    }).catch(function () { b.classList.remove('is-busy'); });
  }

  /* ---- 2. collection stepper ---- */
  var inBag = {};
  function readCart(c) {
    inBag = {};
    (c.items || []).forEach(function (i) {
      var o = inBag[i.handle] || (inBag[i.handle] = { q: 0, key: i.key });
      o.q += i.quantity;
      o.key = i.key;
    });
    paintSteps();
  }
  function paintSteps() {
    Array.prototype.forEach.call(document.querySelectorAll('.bq-step'), function (s) {
      var o = inBag[s.getAttribute('data-handle')], n = o ? o.q : 0;
      s.classList.toggle('has-qty', n > 0);
      s.querySelector('.bq-n').textContent = n;
    });
  }
  function injectSteps() {
    var made = false;
    Array.prototype.forEach.call(document.querySelectorAll('.bc-card'), function (card) {
      if (card.querySelector('.bq-step')) return;
      var media = card.querySelector('.bc-media'), h = handleOf(card);
      if (!media || !h) return;
      var n = nameOf(card) || 'this product';
      var s = document.createElement('div');
      s.className = 'bq-step';
      s.setAttribute('data-handle', h);
      s.innerHTML = '<button type="button" class="bq-dec" aria-label="Remove one ' + n.replace(/"/g, '&quot;') + '">' + MINUS + '</button>' +
        '<span class="bq-n" aria-live="polite">0</span>' +
        '<button type="button" class="bq-inc" aria-label="Add ' + n.replace(/"/g, '&quot;') + ' to bag">' + PLUS + '</button>';
      var wrap = media.parentElement;
      if (!wrap.classList.contains('bq-mwrap')) {
        wrap = document.createElement('div');
        wrap.className = 'bq-mwrap';
        media.parentNode.insertBefore(wrap, media);
        wrap.appendChild(media);
      }
      wrap.appendChild(s);
      made = true;
    });
    if (made) paintSteps();
    return made;
  }
  function stepInc(s) {
    s.classList.add('is-busy');
    addHandle(s.getAttribute('data-handle'), s.closest('.bc-card'))
      .then(function () { return getCart(); }).then(readCart)
      .catch(function () {})
      .then(function () { s.classList.remove('is-busy'); });
  }
  function stepDec(s) {
    var o = inBag[s.getAttribute('data-handle')];
    if (!o || !o.q) return;
    s.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(withSections({ id: o.key, quantity: o.q - 1 }))
    }).then(function (r) { return r.json(); }).then(function (res) {
      announce(res, null);
      readCart(res);
    }).catch(function () {}).then(function () { s.classList.remove('is-busy'); });
  }

  /* ---- 3. the one-shot drawer opener for sections that add on their own ---- */
  var armed = 0;
  var t = null;
  document.addEventListener('cart:update', function (e) {
    var ours = e.detail && e.detail.sourceId === 'beyondads-quickadd';
    if (armed && Date.now() - armed < 8000 && !ours) { armed = 0; setTimeout(openDrawer, 50); }
    /* keep the steppers honest when the bag changes anywhere else (the drawer, other sections) */
    if (!ours && document.querySelector('.bq-step')) {
      clearTimeout(t);
      t = setTimeout(function () { getCart().then(readCart).catch(function () {}); }, 250);
    }
  });

  function act(target) {
    var b = target.closest('.bq-add');
    if (b) { homeAdd(b); return true; }
    var s = target.closest('.bq-step');
    if (s) {
      if (s.classList.contains('is-busy')) return true;
      if (target.closest('.bq-inc')) stepInc(s);
      else if (target.closest('.bq-dec')) stepDec(s);
      return true;
    }
    return false;
  }

  /* touch: act on touchend and cancel the tap, so the card link underneath is never followed */
  var tx = 0, ty = 0, lastTouch = 0;
  document.addEventListener('touchstart', function (e) {
    var p = e.touches && e.touches[0];
    if (p) { tx = p.clientX; ty = p.clientY; }
  }, { capture: true, passive: true });
  document.addEventListener('touchend', function (e) {
    if (!e.target.closest || !e.target.closest('.bq-add,.bq-step')) return;
    var p = e.changedTouches && e.changedTouches[0];
    if (p && (Math.abs(p.clientX - tx) > 10 || Math.abs(p.clientY - ty) > 10)) return; /* it was a swipe */
    e.preventDefault();
    e.stopPropagation();
    lastTouch = Date.now();
    act(e.target);
  }, { capture: true, passive: false });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.bq-add,.bq-step')) {
      e.preventDefault(); e.stopPropagation();
      if (Date.now() - lastTouch < 800) return; /* already handled on touchend */
    }
    var b = e.target.closest('.bq-add');
    if (b) { e.preventDefault(); e.stopPropagation(); homeAdd(b); return; }
    var s = e.target.closest('.bq-step');
    if (s) {
      e.preventDefault(); e.stopPropagation();
      if (s.classList.contains('is-busy')) return;
      if (e.target.closest('.bq-inc')) stepInc(s);
      else if (e.target.closest('.bq-dec')) stepDec(s);
      return;
    }
    if (e.target.closest(THEIRS)) armed = Date.now();
  }, true);
  /* the rails start a drag on pointerdown; a press on a button must not become a drag */
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.target.closest && e.target.closest('.bq-add,.bq-step')) e.stopPropagation();
    }, true);
  });

  function boot() {
    injectHome();
    if (injectSteps()) getCart().then(readCart).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
  /* the collection grid can be re-rendered (sort) - put the steppers back */
  var grid = document.querySelector('[data-bc-root]');
  if (grid && window.MutationObserver) {
    new MutationObserver(function () { if (injectSteps()) getCart().then(readCart).catch(function () {}); })
      .observe(grid, { childList: true, subtree: true });
  }
})();
